import { useEffect } from "react";
import { useForm } from "react-hook-form";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import Modal from "../../layouts/Modal";
import { IInvoice, IInvoiceItem } from "../../models/invoice/IInvoice";
import { DialogTitle } from "@headlessui/react";
import { TextInput } from "../shared/Inputs/TextInput";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import useInvoiceMutations from "../../data/useInvoiceMutations";
import useVatMarginScheme from "../../data/useVatMarginScheme";

interface InvoiceItemModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  invoice: IInvoice | null;
}

export default function InvoiceItemModal({ open, setOpen, invoice }: InvoiceItemModalProps) {
  const { saveHandlers } = useDefaultCRUDHandlers("Invoice Item");
  const { standardRate } = useVatMarginScheme();
  const { register, setValue, getValues, watch, reset, handleSubmit } = useForm<IInvoiceItem>({
    defaultValues: {
      unitPrice: 0,
      quantity: 1,
      taxRate: 20,
      accountCode: "",
      description: "",
      notes: "",
    },
  });
  const { createItem } = useInvoiceMutations();

  useEffect(() => {
    if (open) setValue("taxRate", standardRate);
  }, [open, standardRate, setValue]);

  const onSubmit = (data: any) => {
    const payload: IInvoiceItem = {
      ...data,
      invoiceId: invoice?.id || "",
      partId: null, // Assuming no part is selected
      deleted: null,
      taxRate: parseFloat(data.taxRate) || standardRate,
    };

    createItem.mutate(payload, {
      onSuccess: () => {
        saveHandlers.onSuccess();
        reset();
        setOpen(false);
      },
      onError: (error) => {
        saveHandlers.onError();
      },
    });
  }

  return (
    <Modal open={open} setOpen={setOpen} width="sm:max-w-xl">
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle as="h3" className="text-lg font-medium leading-6 text-gray-900">Invoice Item</DialogTitle>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <div className="sm:col-span-2">
            <TextInput
              label="Description"
              register={register}
              registerName={"description"}
              placeholder="Enter item description"
            />
          </div>

          <TextInput
            label="Unit Price"
            register={register}
            registerName={"unitPrice"}
            placeholder="Enter unit price"
            type="number"
          />
          <TextInput
            label="Quantity"
            register={register}
            registerName={"quantity"}
            placeholder="Enter quantity"
            type="number"
          />
          <TextInput
            label="Tax Rate"
            register={register}
            registerName={"taxRate"}
            placeholder="Enter tax rate"
            type="number"
          />
          <TextInput
            label="Account Code"
            register={register}
            registerName={"accountCode"}
            placeholder="Enter account code"
          />

          <div className="sm:col-span-2">
            <TextInput
              label="Notes"
              register={register}
              registerName={"notes"}
              placeholder="Enter item notes"
              richText={true}
            />
          </div>
        </div>
        <ButtonInput
          isSubmit={true}
          label="Save Item"
          classes="mt-4 float-right"
          onClick={() => {

          }}
        />
      </form>
    </Modal>
  )
}